import type { AppointmentFormValues } from '@/types/appointment-form';

/** `individualServices[]` element for Pre/PostBookCalculatePrice. */
export interface IndividualService {
  id: string;
  type: string;
  quantity: number;
}

/**
 * Map the create-appointment form's selected `addedServices` → the price-calc
 * `individualServices` payload (PROD-1025, F-SCH-182/184).
 *
 * - `serviceType` ('Default' for provider-fee rows, 'all' for catalog rows)
 *   → `IndividualService.type` (the literal the backend keys on).
 * - `quantity` defaults to 1 — mirrors Flutter `IndividualService.toJson`
 *   (`quantity == null ? 1 : quantity`, `calculate_sponsor_amount_request.dart:106`).
 *   The create form has no per-service quantity editor, so every selected
 *   service ships qty 1.
 *
 * Empty in → empty out (the pre-PROD-1025 behavior: no services selected = the
 * profile-only price).
 */
export function addedServicesToIndividualServices(
  addedServices: AppointmentFormValues['addedServices'] | undefined,
): IndividualService[] {
  return (addedServices ?? []).map((s) => ({
    id: s.id,
    type: s.serviceType,
    quantity: 1,
  }));
}
